export default {
  root: '/'
};
